import { render, staticRenderFns } from "./CustomizedTagInput.vue?vue&type=template&id=30625c33&"
import script from "./CustomizedTagInput.vue?vue&type=script&lang=js&"
export * from "./CustomizedTagInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomizedTagInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports